export const Functions = {
  create: false,
  delete: true,
  detail: true,
  search: true
};
export const PageName = '共富启航战略领取记录';